import { phoneExtService } from '@/services/api/phoneExt.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { phoneExt } from '@/models/api/phoneExt.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PHONE_EXT_MODULE = "api/phoneExt";

// ACTIONS
export const GET_ALL_PHONE_EXT = 'getAllPhoneExt';
export const CREATE_PHONE_EXT = 'createPhoneExt';
export const GET_PHONE_EXT = 'getPhoneExt';
export const UPDATE_PHONE_EXT = 'updatePhoneExt';
export const UPDATE_PHONE_EXT_STATUS = 'updatePhoneExtStatus';
export const EXPORT_PHONE_EXT_PDF = 'exportPhoneExtPdf';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PHONE_EXT_SUCCESS = "allPhoneExtSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PHONE_EXT_SUCCESS = "getPhoneExtSuccess";

export const actions = {
    [EXPORT_PHONE_EXT_PDF]({commit}, {data} = {}) {
        commit(REQUESTING, 'save');
        return phoneExtService
            .exportPdf(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE);
            });
    },
    [GET_ALL_PHONE_EXT]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return phoneExtService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PHONE_EXT_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PHONE_EXT]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return phoneExtService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PHONE_EXT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PHONE_EXT]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return phoneExtService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PHONE_EXT_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PHONE_EXT]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return phoneExtService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PHONE_EXT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PHONE_EXT_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return phoneExtService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PHONE_EXT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PHONE_EXT_SUCCESS](state, {data}) {
        let phoneExtList = data.data || [];
        state.list.data = phoneExtList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = phoneExtList.map(item => phoneExt(item));
        }
    },
    [GET_PHONE_EXT_SUCCESS](state, data) {
        state.details = phoneExt(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};

